import { useEffect, useRef, useState } from 'react';
import { routesService } from '@/services/routes';
import { Route } from '@/services/routes/route.vm';
import { Content } from '@/services/contents/content.vm';

const useGetNextContent = ({
  userRouteProgressId,
}: {
  userRouteProgressId: Route['userRouteProgressId'];
}) => {
  const [nextContent, setContent] = useState<{
    id: Content['id'];
    order: Content['order'];
    routeId?: Content['routeId'];
    stageId?: Content['stageId'];
  } | null>();

  const preventGetNextContent = useRef(false);

  useEffect(() => {
    if (!userRouteProgressId || preventGetNextContent.current) return;
    routesService.getNextContent(userRouteProgressId).then((content) => {
      setContent(content);
      preventGetNextContent.current = true;
    });
  }, [userRouteProgressId]);

  return { nextContent };
};

export default useGetNextContent;
